import { Flex } from '@/components/ui/flex'

import SelectSettingsOption from './components/selectSettingsOption/'

const Container = () => {
    return (
        <Flex direction="column">
            <SelectSettingsOption />
        </Flex>
    )
}

export default Container
